import { render, staticRenderFns } from "./applicant-report.vue?vue&type=template&id=f646a4ba"
import script from "./applicant-report.vue?vue&type=script&lang=js"
export * from "./applicant-report.vue?vue&type=script&lang=js"
import style0 from "./applicant-report.vue?vue&type=style&index=0&id=f646a4ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports